/* Animated hex grid — ported from the hivewire.us landing hero so the store
   canvas moves with the same light. Mounts a <canvas> inside the homepage
   canvas section's .section-background; the static lattice (the ::after
   layer) stays as the fallback and is hidden only once the canvas is live.
   Respects prefers-reduced-motion (static lattice remains), pauses offscreen. */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var section = document.querySelector("[id$='__value_band_01']");
  if (!section) return;
  var host = section.querySelector('.section-background');
  if (!host) return;

  var cv = document.createElement('canvas');
  cv.setAttribute('aria-hidden', 'true');
  cv.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;pointer-events:none;';
  host.appendChild(cv);
  section.classList.add('hw-motion');

  var ctx = cv.getContext('2d');
  var W, H, cols, rows, R = 28;
  var sqrt3 = Math.sqrt(3), cw = sqrt3 * R, rh = R * 1.5;
  function resize() {
    W = cv.width = host.clientWidth;
    /* The section is the whole homepage front; animating all of it would be
       thousands of strokes per frame. Cap to the first screenful-plus and
       dissolve at the bottom edge. */
    H = cv.height = Math.min(host.clientHeight, Math.max(window.innerHeight * 1.4, 900));
    cv.style.height = H + 'px';
    cols = Math.ceil(W / cw) + 2; rows = Math.ceil(H / rh) + 3;
  }
  function hexPath(cx, cy) {
    ctx.beginPath();
    for (var i = 0; i < 6; i++) {
      var a = Math.PI / 3 * i - Math.PI / 6;
      ctx.lineTo(cx + R * Math.cos(a), cy + R * Math.sin(a));
    }
    ctx.closePath();
  }
  function draw(t) {
    ctx.clearRect(0, 0, W, H);
    var off = (t * 0.012) % (rh * (rows + 4) * 100);
    for (var r = -2; r < rows + 2; r++) {
      for (var c = -1; c < cols; c++) {
        var x = c * cw + (r % 2 ? cw / 2 : 0);
        var y = ((r * rh - off) % ((rows + 4) * rh) + ((rows + 4) * rh)) % ((rows + 4) * rh) - 2 * rh;
        var dx = x - W / 2, dy = y - H / 2, dist = Math.sqrt(dx * dx + dy * dy);
        var maxD = Math.sqrt(W * W + H * H) / 2;
        var fade = 1 - Math.min(dist / maxD, 1);
        fade = fade * fade;
        /* dissolve toward the canvas's bottom edge */
        var edge = 1 - Math.max(0, (y - (H - 260)) / 260);
        fade *= Math.max(0, Math.min(1, edge));
        var pulse = 0.5 + 0.5 * Math.sin(t * 0.001 + c * 0.3 + r * 0.2);
        var alpha = fade * (0.15 + 0.2 * pulse);
        if (alpha < 0.005) continue;
        ctx.strokeStyle = 'rgba(245,166,35,' + alpha.toFixed(3) + ')';
        ctx.lineWidth = 1.2;
        hexPath(x, y); ctx.stroke();
      }
    }
  }
  var running = true, raf;
  function loop(t) { if (running) { draw(t); raf = requestAnimationFrame(loop); } }
  resize();
  window.addEventListener('resize', resize);
  raf = requestAnimationFrame(loop);
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { if (!running) { running = true; raf = requestAnimationFrame(loop); } }
      else { running = false; cancelAnimationFrame(raf); }
    }, { threshold: 0 }).observe(section);
  }
})();
